import { translate, useLocale } from "../../localization";
import React, { useState } from "react";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import API from "../../services/API";
import { AppButton } from "../ui";
import GenerateElementDialog from "./GenerateElementDialog";
import { useContent } from "../../context/ContentContext";

const AiElementGenerator = ({ onNewElementCreated }) => {
  useLocale();
  const [dialogOpen, setDialogOpen] = useState(false);
  const { upsertMyElement, patchMyElement, trackElementBuild } = useContent();

  const handleUpload = async ({ generationId, element }) => {
    if (!generationId || !element) {
      return null;
    }

    const pendingElement = {
      id: element.id,
      name: element.labelData?.displayName || "",
      description: element.labelData?.description || "",
      dateModified: new Date().toISOString(),
      status: {
        type: "BUILDING",
        timestamp: new Date().toISOString(),
      },
    };

    upsertMyElement(pendingElement, { prepend: true });

    try {
      const response = await API.post(
        `ai/models/${generationId}/element`,
        { element },
        { requiresAuth: true }
      );
      const createdElement = response?.data?.data || pendingElement;

      trackElementBuild(element.id, {
        ...pendingElement,
        ...createdElement,
      });

      if (onNewElementCreated) {
        onNewElementCreated(createdElement);
      }

      return createdElement;
    } catch (error) {
      patchMyElement(element.id, {
        status: {
          type: "BUILDING_FAILED",
          timestamp: new Date().toISOString(),
          message: error?.response?.data?.message || error?.message || translate("Upload failed"),
        },
      });
      throw error;
    }
  };

  return (
    <>
      <AppButton
        kind="secondary"
        onClick={() => setDialogOpen(true)}
        startIcon={<AutoAwesomeIcon fontSize="small" />}
      >{translate("Generate with AI")}</AppButton>
      <GenerateElementDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onUpload={handleUpload}
      />
    </>
  );
};

export default AiElementGenerator;
